import Success from "../assets/success.svg";
import { t } from "../i18n";

export default function () {
  return (
    <div class="flex flex-col gap-2 items-center justify-center self-center my-auto text-center">
      <Success />
      <p class="text-30px font-bold">{t().success.attendance.title}</p>
      <span class="text-18px">{t().success.attendance.subtitle}</span>
    </div>
  );
}
